const AUTH_EVENT_STORAGE_KEY = "myteengig:auth:event";
const AUTH_LOGOUT_EVENT = "myteengig:auth:logout";

type AuthLogoutEventDetail = {
  reason: string;
  at: number;
};

export const broadcastLogoutEvent = (reason: string) => {
  const detail: AuthLogoutEventDetail = {
    reason,
    at: Date.now(),
  };

  window.localStorage.setItem(AUTH_EVENT_STORAGE_KEY, JSON.stringify(detail));
  window.dispatchEvent(new CustomEvent<AuthLogoutEventDetail>(AUTH_LOGOUT_EVENT, { detail }));
};

export const AUTH_EVENTS = {
  logoutStorageKey: AUTH_EVENT_STORAGE_KEY,
  logoutEventName: AUTH_LOGOUT_EVENT,
} as const;
